export default "__VITE_ASSET__c40f5036__"